var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",on:{"click":_vm.onClickHeader}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/owl-teal.svg")}}),_c('span',{staticClass:"header-text display-2"},[_vm._v("Puzzle Of the Day")])])}
var staticRenderFns = []

export { render, staticRenderFns }